import type {
	ResponsiveProductCardSettings,
	ScreenSize,
} from 'product-card/context/ProductCardConsumerLayoutContext/ProductCardConsumerLayoutContext'
import { ProductCardIcon } from 'product-card/types'
import type { View } from 'product-list/types/View'

export function applyOverlayAbTestSettings(
	settings: Record<View, ResponsiveProductCardSettings>
) {
	const { inspirational, standard } = settings
	const sizesToUpdate = ['small', 'medium'] as ScreenSize[]

	for (const size of sizesToUpdate) {
		inspirational[size] = {
			...inspirational[size],
			hasSizeSheetButton: false,
			// TODO: When Ab Test is cleaned up, we must take in account that countries without online sale must not have the overlay add to bag button
			hasOverlayAddToBag: true,
		}

		standard[size] = {
			...standard[size],
			hasSizeSheetButton: false,
			hasOverlayAddToBag: true,
			detailsIcon: ProductCardIcon.None,
		}
	}
}
